import { defineComponent as p, openBlock as a, createElementBlock as o, mergeProps as m, unref as e, renderSlot as u, createElementVNode as n, createCommentVNode as v } from "vue";
import { useScalarIcon as V } from "../hooks/useScalarIcon.js";
const g = { key: 0 }, Z = { key: 1 }, H = { key: 2 }, A = { key: 3 }, f = { key: 4 }, h = { key: 5 }, k = {
  name: "ScalarIconTextUnderline"
}, y = /* @__PURE__ */ p({
  ...k,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: l } = V(s);
    return (i, t) => (a(), o("svg", m({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      u(i.$slots, "default"),
      e(l) === "bold" ? (a(), o("g", g, t[0] || (t[0] = [
        n("path", { d: "M204,224a12,12,0,0,1-12,12H64a12,12,0,0,1,0-24H192A12,12,0,0,1,204,224Zm-76-28a68.07,68.07,0,0,0,68-68V56a12,12,0,0,0-24,0v72a44,44,0,0,1-88,0V56a12,12,0,0,0-24,0v72A68.07,68.07,0,0,0,128,196Z" }, null, -1)
      ]))) : e(l) === "duotone" ? (a(), o("g", Z, t[1] || (t[1] = [
        n("path", {
          d: "M184,56v80a56,56,0,0,1-112,0V56Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M200,224a8,8,0,0,1-8,8H64a8,8,0,0,1,0-16H192A8,8,0,0,1,200,224Zm-72-24a64.07,64.07,0,0,0,64-64V56a8,8,0,0,0-16,0v80a48,48,0,0,1-96,0V56a8,8,0,0,0-16,0v80A64.07,64.07,0,0,0,128,200Z" }, null, -1)
      ]))) : e(l) === "fill" ? (a(), o("g", H, t[2] || (t[2] = [
        n("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM80,72a8,8,0,0,1,16,0v48a32,32,0,0,0,64,0V72a8,8,0,0,1,16,0v48a48,48,0,0,1-96,0Zm96,128H80a8,8,0,0,1,0-16h96a8,8,0,0,1,0,16Z" }, null, -1)
      ]))) : e(l) === "light" ? (a(), o("g", A, t[3] || (t[3] = [
        n("path", { d: "M198,224a6,6,0,0,1-6,6H64a6,6,0,0,1,0-12H192A6,6,0,0,1,198,224Zm-70-26a62.07,62.07,0,0,0,62-62V56a6,6,0,0,0-12,0v80a50,50,0,0,1-100,0V56a6,6,0,0,0-12,0v80A62.07,62.07,0,0,0,128,198Z" }, null, -1)
      ]))) : e(l) === "regular" ? (a(), o("g", f, t[4] || (t[4] = [
        n("path", { d: "M200,224a8,8,0,0,1-8,8H64a8,8,0,0,1,0-16H192A8,8,0,0,1,200,224Zm-72-24a64.07,64.07,0,0,0,64-64V56a8,8,0,0,0-16,0v80a48,48,0,0,1-96,0V56a8,8,0,0,0-16,0v80A64.07,64.07,0,0,0,128,200Z" }, null, -1)
      ]))) : e(l) === "thin" ? (a(), o("g", h, t[5] || (t[5] = [
        n("path", { d: "M196,224a4,4,0,0,1-4,4H64a4,4,0,0,1,0-8H192A4,4,0,0,1,196,224Zm-68-28a60.07,60.07,0,0,0,60-60V56a4,4,0,0,0-8,0v80a52,52,0,0,1-104,0V56a4,4,0,0,0-8,0v80A60.07,60.07,0,0,0,128,196Z" }, null, -1)
      ]))) : v("", !0)
    ], 16));
  }
});
export {
  y as default
};
